import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const DealsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Deals",
    children: /*#__PURE__*/_jsx("path", {
      d: "m16.5 14.34-1.9 1.7c-.55.46-1.27.74-2.05.74-.98 0-1.85-.44-2.44-1.12-.47-.56-.75-1.28-.75-2.07 0-.98.44-1.86 1.13-2.45s1.46-1.39 1.46-1.39l.73-.61.97-.81s.05-.04.07-.07c.26-.25.43-.6.43-.99 0-.32-.11-.62-.3-.85-.25-.3-.63-.5-1.06-.5-.33 0-.63.12-.87.31S6 11.08 6 11.08H3.35c-.76 0-1.37.61-1.37 1.37v8.79s-.01.09-.01.15 0 .1.01.15 0 .02 0 .03v.04c.02.07.05.14.08.2s.03.05.05.08c.03.06.07.11.1.15s.07.08.07.08c.04.05.07.09.12.12s.04.04.04.04c.1.08.21.14.34.19s.07 0 .07 0c.12.05.26.07.41.07h4.55l2.14 2.23c.25.26.6.42.99.42.41 0 .78-.18 1.04-.47.19-.24.3-.55.3-.89 0-.4-.16-.76-.42-1.02v-.04c-.17-.17-.28-.4-.28-.66s.11-.49.28-.66c.16-.16.39-.26.64-.26.27 0 .5.11.67.29s4.03 4.17 4.03 4.17c.25.26.6.42.98.42.42 0 .79-.19 1.04-.48a1.464 1.464 0 0 0-.11-1.9s-1.71-1.77-1.71-1.77c-.17-.17-.28-.4-.28-.66s.11-.49.28-.66c.17-.16.4-.26.65-.26.27 0 .5.11.67.29s3.16 3.27 3.16 3.27c.25.26.6.42.99.42.76 0 1.37-.61 1.37-1.37 0-.37-.15-.71-.38-.95s-7.4-7.66-7.4-7.66Zm12.26-3.24h-2.77l-5.81-4.43h-.04s-.1-.07-.16-.1a.64.64 0 0 0-.3-.11s-.05 0-.05 0h-.52c-.09.01-.18.04-.26.07s-.04 0-.04 0c-.08.03-.15.07-.22.11-.07.05-.14.1-.2.16s-5.08 4.23-5.08 4.23l-1.65 1.52c-.3.25-.5.63-.5 1.05 0 .76.61 1.37 1.37 1.37h.03c.33 0 .63-.12.86-.32s1.79-1.64 1.79-1.64l1.42-1.18.81.84 8.57 8.89c.61.63 1.46 1.02 2.41 1.02h.31c.15 0 .29-.03.43-.07h-.01.06c.07-.04.13-.07.19-.11s.16-.1.16-.1v-.04l.12-.12s.06-.06.08-.09.06-.1.09-.15.04-.06.04-.09c.03-.05.06-.12.08-.18s0-.04 0-.05v-9.11c0-.72-.54-1.3-1.23-1.37Z"
    })
  }));
};